import Vue from 'vue'
import Router from 'vue-router'
import storage from '../storage'
import { constantRouterMap } from './router'
import { isEmpty } from 'lodash'
import { preloadHomeBackground } from '@/utils/preloadHomeBackground'

function preloadHomeIfNeeded(to) {
  if (to.path !== '/') {
    return
  }
  const userInfo = storage.getters.userInfo || {}
  preloadHomeBackground(userInfo.tenantId)
}

Vue.use(Router)

const routers = {
  mode: 'history',
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  base: process.env.BASE_URL,
  routes: constantRouterMap
}
// if (process.env.NODE_ENV === 'development') {
//     // 开发环境
//     routers.routes.push(
//         {
//             // 获取省市区三级json数据
//             path: '/getAreaJson',
//             component: () => AsyncComponent(import('@/views/reg/GetAreaJson')),
//             name: 'getAreaJson'
//         }
//     )
// }

const router = new Router(routers)
const whiteList = ['login', 'register', 'registerResult'] // no redirect whitelist
router.beforeEach((to, from, next) => {
  // 判断是否已登录，已登录的获取下当前用户基本信息
  if (storage.getters.IsLogin) {
    if (isEmpty(storage.getters.addRouters)) {
      // eslint-disable-next-line no-unused-vars
      Promise.all(([storage.dispatch('GetUserInfo'), storage.dispatch('GetProvinceInfo'), storage.dispatch('GetPermissionsInfo')])).then(([userInfoResp, provinceInfo, permissionInfo]) => {
        preloadHomeBackground(userInfoResp?.data?.tenantId)
        storage.dispatch('GenerateRoutes', permissionInfo).then(() => {
          router.addRoutes(storage.getters.addRouters)
          if (permissionInfo.length === 1 && to.path === '/') {
            next({ path: permissionInfo[0].url })
          } else {
            next({ path: to.path, query: to.query, params: to.params })
          }
        })
      })
    } else {
      preloadHomeIfNeeded(to)
      if (to.path === '/sign') {
        next({ path: '/' })
      } else {
        next()
      }
    }
  } else {
    if (whiteList.includes(to.name)) {
      // 在免登录白名单，直接进入
      next()
    } else {
      next({ path: '/sign' })
    }
  }
})
router.afterEach(to => {
  const pathName = to.meta && to.meta.title
  if (pathName !== '系统登录' && pathName !== '用户信息' && pathName !== '使用过期') {
    storage.dispatch('PushUserLog', {
      page: pathName,
      operation: '打开页面'
    })
  }
  // 百度统计事件追踪
  storage.dispatch('PushHmtTrackEvent', {
    category: to.meta.title,
    action: '访问',
    optLabel: to.path
  })
})
export default router
